import React, { Component } from 'react';
import HeaderTitle from '../HeaderTitle';
import { Form, Label, Input, Button } from '../Form';
import Errors from '../Errors';
import api from '../../utils/api';
import withTranslations from '../../utils/translations/withTranslations';

import './PasswordForgot.css';

class PasswordForgot extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: false,
      isBusy: false,
      success: false
    };
  }

  submit(data) {
    this.setState({ isBusy: true });

    api
      .post('/auth/password/email', data)
      .then(() => this.setState({ success: true }))
      .catch(({ data: errors }) => this.setState({ isBusy: false, errors }));
  }

  render() {
    const { isValid, errors, isBusy, success } = this.state;
    const { translate } = this.props;

    return (
      <div className="PasswordForgot">
        <div className="PasswordForgot__Header">
          <HeaderTitle />
        </div>
        <div className="PasswordForgot__Content">
          <h1>{translate('password_forgot.title')}</h1>
          {success && (
            <div>
            {translate('password_forgot.success')}
            </div>
          )}
          {!success && (
          <Form
            ref={form => (this.form = form)}
            onValidationChange={valid => this.setState({ isValid: valid })}
            onSubmit={data => this.submit(data)}
          >
            <Errors errors={errors} />
            {translate('password_forgot.message')}
            <Label text={translate('password_forgot.email')} />
            <Input rules={['required', 'email']} name="email" />
            <Button
              solid
              className="Form__Button"
              disabled={!isValid || isBusy}
            >
              {translate('password_forgot.submit')}
            </Button>
          </Form>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslations(PasswordForgot);
